<svelte:head>
  <title>Accessibility | eAdmissions</title>
</svelte:head>
<script>
  import Help from "../help.svelte";
  </script>

  <Help helpId={"Accessibility"} showSearchOption={false} back="/about"/>